<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-board :config="config" />
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="显示本年的EI数据，按创建时间查询，查询审批通过的EI，显示提交次数 TOP20 的用户" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "lpa-left",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: this.beans,
      config: {
        startCharts: "",
        header: ["排名", "工号", "姓名", "部门","积分"],
        headerBGC: "#018DCE",
        evenRowBGC: "#000D4A",
        rowNum: 4,
        columnWidth: [120],
        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        for (var i = 0; i < this.dataList.length; i++) {
         var top = this.dataList[i]["top"];
          var username = this.dataList[i]["username"];
          var name = this.dataList[i]["name"];
          var dept = this.dataList[i]["dept"];
          var eiCount=this.dataList[i]['count'];
     //     var value = [top, username, name, dept];
         var value = [username, name, dept,eiCount];
          data.push(value);
        }

        this.config = {
          index:true,
         indexHeader:'排名',
          startCharts: "",
      //    header: ["排名", "工号", "姓名", "部门"],
        header: ["工号", "姓名", "部门","积分"],
          headerBGC: "#018DCE",
          evenRowBGC: "#000D4A",
          rowNum: 8,
          align:'center',
          columnWidth: [200,200],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "MM/dd");
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ei/component/ei-top-list.vue